import { Component } from '@verndale/core';
import VideoModal from './modals/video-modal';

class GenericOverview extends Component {
  setupDefaults() {
    this.dom = {
      play: this.el.querySelector('.generic-overview__play'),
      videoModal: this.el.querySelector('.video-modal'),
      overviewContainer: this.el.querySelector('.generic-overview__container'),
      figure: this.el.querySelector('.generic-overview__figure')
    };
    this.mobileMediaQuery = window.matchMedia('only screen and (max-width: 979px)');
    this.isMobile = this.mobileMediaQuery.matches;

    if (this.dom.videoModal) {
      this.videoModal = new VideoModal(this.dom.videoModal, {
        onPlayerReady: ::this.enablePlay
      });
    }

    this.setContainerHeight();
  }

  addListeners() {
    if (this.dom.play && this.dom.videoModal) {
      this.dom.play.addEventListener('click', ::this.showVideoModal);
    }

    if (this.dom.figure) {
      window.addEventListener('resize', () => {
        this.isMobile = this.mobileMediaQuery.matches;
        this.setContainerHeight();
      });
    }
  }

  showVideoModal() {
    this.videoModal.show();
  }

  enablePlay() {
    this.dom.play.disabled = false;
  }

  setContainerHeight() {
    if (!this.dom.figure || !this.dom.overviewContainer) return;

    if (this.isMobile) {
      this.dom.overviewContainer.style.height = 'auto';
      return;
    }

    this.dom.overviewContainer.style.height = 'auto';
    const figureHeight = this.dom.figure.offsetHeight;
    const oneThirdHeight = figureHeight / 3;
    const naturalHeight = this.dom.overviewContainer.offsetHeight;
    this.dom.overviewContainer.style.height = `${naturalHeight + oneThirdHeight}px`;
  }
}

export default GenericOverview;
